(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee-section"] && !Shopify.designMode) return;
  try {
    
  function setupMarqueeRotator(section) {
    var viewport = section.querySelector('[data-rotate-viewport]');
    if (!viewport) return;

    var items = Array.prototype.slice.call(viewport.querySelectorAll('[data-rotate-text]'));
    if (items.length < 2) return; // nothing to rotate between

    var interval = parseInt(section.getAttribute('data-rotate-interval'), 10) || 3000;
    var transitionDuration = parseInt(section.getAttribute('data-transition-duration'), 10) || 500;

    var activeIndex = 0;
    var timer = null;
    var paused = false;

    function goToNext() {
      if (paused) return;

      var current = items[activeIndex];
      var nextIndex = (activeIndex + 1) % items.length;
      var next = items[nextIndex];

      // Snap the incoming item below the viewport instantly (no transition),
      // in case it still carries a stale state from a previous cycle.
      next.classList.remove('is-active', 'is-leaving');
      next.classList.add('is-waiting-below');

      // Force a reflow so the "no transition" snap above is applied before
      // we re-enable the transition below.
      // eslint-disable-next-line no-unused-expressions
      next.offsetHeight;

      // Outgoing item slides up and fades out.
      current.classList.remove('is-active');
      current.classList.add('is-leaving');

      window.requestAnimationFrame(function () {
        // Release the incoming item from "waiting below" so its normal
        // transition takes over and animates it up into the center.
        next.classList.remove('is-waiting-below');
        next.classList.add('is-active');
      });

      activeIndex = nextIndex;
    }

    function start() {
      stop();
      timer = window.setInterval(goToNext, Math.max(interval, transitionDuration + 300));
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    section.addEventListener('mouseenter', function () {
      if (section.classList.contains('marquee--pause-hover')) {
        paused = true;
      }
    });
    section.addEventListener('mouseleave', function () {
      paused = false;
    });

    start();
  }

  function initAllMarquees(scope) {
    (scope || document).querySelectorAll('[data-marquee-section]').forEach(function (section) {
      if (section.dataset.marqueeInit === 'true') return;
      section.dataset.marqueeInit = 'true';
      setupMarqueeRotator(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllMarquees(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.dataset.marqueeInit = '';
    var el = event.target.querySelector('[data-marquee-section]');
    if (el) el.dataset.marqueeInit = '';
    initAllMarquees(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
